import types from './types';

import { getValidationMessages as _getValidationMessages } from '../api';

export default {
    async getValidationMessages(context, messagesCodes) {
        const validationMessages = await _getValidationMessages(messagesCodes);
        context.commit(types.SET_VALIDATION_MESSAGES, validationMessages);
    },

    async setSelectedReportType(context, reportType) {
        context.commit(types.SET_SELECTED_REPORT_TYPE, reportType);
    },

    setFilterText(context, text) {
        context.commit(types.SET_FILTER_TEXT_TYPE, text)
    },
}